import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, IconButton } from '../_common';
import { MediaGalleryConstants } from '../../constants';
import LogoIcon from '../../icons/2key_logo.svg';
import IpfsLogo from '../../icons/IPFS.png';

const style = type => {
  let width;
  let height;
  switch (type) {
  case 'Logo':
    width = 25;
    height = 25;
    break;
    // case 'Cover':
    //   width = 55;
    //   height = width / CROP_RATE.Cover;
    //   break;
  case 'Cover':
    width = 75;
    height = width / MediaGalleryConstants.CROP_RATE.Cover;
    break;
  case 'Campaign':
  default:
    width = 45;
    height = width / MediaGalleryConstants.CROP_RATE.Campaign;
  }
  return {
    width,
    height,
  };
};

const Footer = ({
  intl: { formatMessage }, activeTab, crop, selection, uploading, deleteSelectedMedia, forbiddenType,
  onCancel, onConfirm, onCropTemplateClick,
}) => (
  <div className="modal-footer border-top flex" style={{ background: '#E8F0F2', height: 50 }}>
    {activeTab === 1 && crop.on !== activeTab && (
      <div className="flex-1">
        <IconButton style={{ color: '#95989A' }} icon="trash" onClick={deleteSelectedMedia} />
      </div>
    )}
    {activeTab === 3 && (
      <div className="flex-1 pixabay-banner">
        <span className="pixabay">
          <FormattedMessage
            id="media.powered_by_pixabay"
            values={{
              link: <a href="https://pixabay.com/" target="_blank" rel="noopener noreferrer">Pixabay</a>,
            }}
          />
        </span>
      </div>
    )}
    {!crop.on && (
      <div className="poweredby">
        <FormattedMessage
          id="media.powered_by_ipfs"
          defaultMessage="{logo}Smart Links Media is stored on{ipfs}decentralised storage"
          values={{
            logo: <img className="poweredby__site-logo" src={LogoIcon} alt="2KeyLogo" />,
            ipfs: <img className="poweredby__ipfs-logo" src={IpfsLogo} alt="IpfsLogo" />,
          }}
        />
      </div>
    )}
    {crop.on === activeTab && (
      <div className="cropping-toolbar-container">
        <div className="cropping-toolbar-title">
          <FormattedMessage id="media.best_fit" defaultMessage="!Best Fit For" />
        </div>
        {Object.keys(MediaGalleryConstants.CROP_RATE).map(key => (
          <div
            key={`crop-option-${key}`}
            className={`cropping-toolbar-option-wrapper${crop.rate === MediaGalleryConstants.CROP_RATE[key]
              ? ' selected' : ''}`}
            data-croprate={key}
            onClick={onCropTemplateClick}
          >
            <div className="cropping-toolbar-option">
              <div className="cropping-toolbar-option-img-wrapper">
                <div className="cropping-toolbar-option-img" style={style(key)} />
              </div>
              <div className="cropping-toolbar-option-label">{key}</div>
            </div>
          </div>
        ))}
        <div className="flex-1">&nbsp;</div>
      </div>
    )}
    <Button
      bsType="cancel"
      title={formatMessage({ id: 'main.cancel', defaultMessage: '!Cancel' })}
      onClick={onCancel}
    />&nbsp;
    <Button
      title={formatMessage({ id: 'main.confirm', defaultMessage: '!Confirm' })}
      onClick={onConfirm}
      disabled={((!crop || !crop.image) && (!selection || !selection.media)) || uploading || forbiddenType}
    />
  </div>
);

Footer.propTypes = {
  uploading: PropTypes.bool,
  forbiddenType: PropTypes.bool,
  activeTab: PropTypes.number,
  crop: PropTypes.object,
  selection: PropTypes.object,
  intl: PropTypes.object.isRequired,
  deleteSelectedMedia: PropTypes.func.isRequired,
  onCropTemplateClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default injectIntl(Footer);
